import { findAllTrialApplications, mapClientError, queryKeys } from "@dutyon/apis";
import {
  Alert,
  Badge,
  Button,
  Card,
  LoadingOverlay,
  Stack,
  TableContainer,
  Text,
  TitleContainer,
} from "@dutyon/ui-kit";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { parseAsInteger, useQueryState } from "nuqs";
import { useNavigate } from "react-router-dom";
import { TrialApplicationTable } from "../../components/TrialApplicationTable";

export function TrialApplicationListPage() {
  const navigate = useNavigate();
  const [page, setPage] = useQueryState("page", parseAsInteger.withDefault(1));
  const [limit, setLimit] = useQueryState("limit", parseAsInteger.withDefault(20));

  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    queryKey: queryKeys.trialApplications.list(page, limit),
    queryFn: () => findAllTrialApplications({ page, limit }),
    placeholderData: keepPreviousData,
  });
  const applications = data?.list || [];
  const total = data?.total || 0;

  return (
    <TitleContainer
      size="xl"
      py="xl"
      title="체험하기 신청 목록"
      rightSection={<Badge size="lg">총 {total}건</Badge>}
    >
      <Stack gap="lg">
        <Card withBorder p="lg" radius="md" pos="relative">
          <LoadingOverlay visible={isLoading || isFetching} />
          {isError && (
            <Alert color="red" title="체험 신청 목록을 불러오지 못했습니다.">
              <Stack gap="sm">
                <Text size="sm">
                  {mapClientError(error, { fallback: "잠시 후 다시 시도해 주세요." }).message}
                </Text>
                <Button size="xs" w="fit-content" onClick={() => void refetch()}>
                  다시 시도
                </Button>
              </Stack>
            </Alert>
          )}
          {!isError && (
            <TableContainer
              page={page}
              onPageChange={setPage}
              limit={limit}
              onLimitChange={setLimit}
              total={total}
              minWidth={1_100}
            >
              <TrialApplicationTable
                applications={applications}
                isLoading={isLoading}
                onDetailClick={(id: string) => navigate(`/trial-applications/${id}`)}
              />
            </TableContainer>
          )}
        </Card>
      </Stack>
    </TitleContainer>
  );
}
